import { useState } from "react";
import { Navigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../lib/auth";
import { useLang } from "../lib/i18n";
import { Field, useBusy } from "../components/common";

export default function Login() {
  const { user, setUser } = useAuth();
  const { t, lang, setLang } = useLang();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, run] = useBusy();
  if (user) return <Navigate to="/" replace />;
  const submit = (e) =>
    run(async () => {
      e.preventDefault();
      try {
        const { data } = await api.post("/auth/login", { email, password });
        if (data.lang) setLang(data.lang, false);
        setUser(data);
      } catch (err) {
        toast.error(errMsg(err));
      }
    });
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-white">
      <div className="hidden lg:block relative bg-slate-900">
        <img src="https://images.unsplash.com/photo-1595989329151-8c80761a989b?auto=format&fit=crop&w=1200&q=70" alt="" className="absolute inset-0 w-full h-full object-cover opacity-60" />
        <div className="absolute bottom-0 p-12 text-white">
          <div className="text-4xl font-extrabold leading-tight">H Calix Stucco<br />Design & Paint LLC</div>
          <p className="mt-3 text-slate-200 max-w-md">{t("Business management for the office and the field.", "Administración del negocio para la oficina y el campo.")}</p>
        </div>
      </div>
      <div className="flex flex-col justify-center px-6 py-10 sm:px-16">
        <div className="flex justify-between items-center mb-10">
          <span className="grid place-items-center w-12 h-12 rounded-xl bg-[#D9531E] text-white font-extrabold text-lg">HC</span>
          <button className="btn-outline btn-sm" onClick={() => setLang(lang === "en" ? "es" : "en", false)} data-testid="login-lang-toggle">
            {lang === "en" ? "Español" : "English"}
          </button>
        </div>
        <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight">{t("Sign in", "Iniciar sesión")}</h1>
        <p className="text-slate-500 mt-2 mb-8">H Calix Stucco Design & Paint LLC</p>
        <form onSubmit={submit} className="grid gap-4 max-w-md">
          <Field label={t("Email", "Correo")}>
            <input className="inp" type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" />
          </Field>
          <Field label={t("Password", "Contraseña")}>
            <input className="inp" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" />
          </Field>
          <button className="btn-primary h-14 text-base" disabled={busy} data-testid="login-submit-btn">
            {busy ? t("Signing in…", "Entrando…") : t("Sign in", "Entrar")}
          </button>
          <Link to="/forgot-password" className="text-sm font-semibold text-[#D9531E]" data-testid="login-forgot-password-link">{t("Forgot password?", "¿Olvidó su contraseña?")}</Link>
          <p className="text-xs text-slate-400">{t("Accounts are created by the owner in Team & Permissions.", "Las cuentas las crea el dueño en Equipo y permisos.")}</p>
        </form>
      </div>
    </div>
  );
}
